import { AfterViewInit, ChangeDetectorRef, Component, inject, ViewChild } from '@angular/core';
import { TableComponent } from '../../../components/table/table.component';
import { MatExpansionPanel } from '@angular/material/expansion';
import { FilterHolidays } from '../../../models/filters/filter-holidays';
import { Router } from '@angular/router';
import { HolidaysService } from '../../../services/holiday.service';
import { tableModel } from '../../../components/table/model/tableModel';
import { AlertaService } from '../../../services/alerta.service';

@Component({
  selector: 'app-holidays',
  standalone: false,
  templateUrl: './holidays.component.html',
  styleUrl: './holidays.component.css'
})
export class HolidaysComponent implements AfterViewInit{

  ngAfterViewInit(): void {
    throw new Error('Method not implemented.');
  }

  @ViewChild(TableComponent) holidaysTable:TableComponent | undefined;
  @ViewChild('advancedPanel') advancedPanel!: MatExpansionPanel;
  
  tableModel: tableModel= {
    columnModel:[
      {columnName:'#',columnValue:'id'},
      {columnName:'Descripción',columnValue:'description'}
    ],
    dataSource: [],
    editButton:true
  };
  pageIndex: number = 1;
  pageSize: number = 5;
  loading: boolean = false;
  filterHolidays: FilterHolidays = new FilterHolidays;
  advancedSearch: boolean = false;

  private holidaysService = inject(HolidaysService);
  router = inject(Router);
  private cdr = inject(ChangeDetectorRef);
  private alerta = inject(AlertaService);

  ngOnInit(): void {
      this.filterHolidays = new FilterHolidays();
      this.searchHolidaysPaginator();
  }
  paginatorEvent(event: any){
    this.pageIndex = (event.pageIndex+1);
    this.pageSize = event.pageSize;
    this.searchHolidaysPaginator();
  }

  editEvent(event: any){
    this.router.navigate(['/holidays/edit', event.id]);
  }

  searchHolidaysPaginatorAS(){
    this.pageIndex = 1;
    this.advancedSearch = true;
    this.searchHolidaysPaginator();
  }

  searchHolidaysPaginator(){
    this.loading = true;

    this.holidaysService.findAllPageableHolidays(this.filterHolidays, this.pageIndex, this.pageSize).subscribe({
      next: (pageable) => {
        this.tableModel.pageSize = pageable.pageSize;
        this.tableModel.totalRecords = pageable.itemsCount;
        this.tableModel.dataSource = pageable.list;
        this.tableModel.pageNumber = pageable.pageNum;
        
        setTimeout(() => {
          this.holidaysTable?.refresh(pageable.list, pageable.itemsCount);
        });
        this.loading = false;
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.loading = false;
        if(err.status == 400){
          this.alerta.error("Se ha terminado el tiempo de session: ", {detail: err.message});
          this.router.navigate(['/login']);
        }else{
          this.alerta.error("Se ha precentado un error interno: ", {detail: err.message});
        }
      }
    });

    if(this.advancedPanel != null){
      if (this.advancedSearch) {
        this.advancedPanel.open();
      } else {
        this.advancedPanel.close();
      }
    }
  }

  addNewGroupHolidays(){
    this.router.navigate(['/holidays/edit', 0]);
  }

}
